import { SUPPORT_EMAIL } from '@psyomics/ui-common';
import { TFunction, TOptions } from 'i18next';

type FormFieldError = { message?: string };
type FormErrors<T> = Partial<Record<keyof T, FormFieldError>> & { root?: FormFieldError };

const mapErrorToTranslationArgs = (errorMessage: string): [string] | [string, TOptions] => {
  const errorMap: Record<string, string> = {
    'Invalid credentials': 'auth.common.errors.invalidCredentials',
    'Invalid username or password': 'auth.common.errors.invalidCredentials',
    'Missing password fields': 'auth.common.errors.missingPasswordFields',
    'Must be a valid mobile number': 'auth.common.errors.phoneNumberInvalid',
    'country code required': 'auth.common.errors.phoneNumberCountryCodeRequired',
    'login failed': 'auth.common.errors.invalidCredentials',
    'mfa login failed': 'auth.common.mfa.errors.mfaVerificationFailed',
    'mfa verification failed': 'auth.common.mfa.errors.mfaVerificationFailed',
    'resend code failed': 'auth.common.mfa.errors.resendCodeFailed',
  };

  return errorMap[errorMessage] ? [errorMap[errorMessage]] : ['common.errors.generic', { supportEmail: SUPPORT_EMAIL }];
};

export const collectFormErrors = <T extends Record<string, unknown>>(
  errors: FormErrors<T>,
  t: TFunction,
  fieldKeys?: (keyof T)[]
): string[] => {
  const errorMessages: string[] = [];

  const keysToCheck = fieldKeys || (Object.keys(errors).filter((key) => key !== 'root') as (keyof T)[]);

  keysToCheck.forEach((key) => {
    const message = errors[key]?.message;
    if (message) {
      errorMessages.push(message);
    }
  });

  if (errors.root?.message) {
    const translationArgs = mapErrorToTranslationArgs(errors.root.message);
    errorMessages.push(t(...translationArgs));
  }

  return errorMessages;
};

export type { FormErrors, FormFieldError };
